import { NgModule } from '@angular/core';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { OnboardingStartPage } from '../pages/onboarding/onboarding-start/onboarding-start.page';
import { OnboardingStatusPage } from '../pages/onboarding/onboarding-status/onboarding-status.page';
import { OnboardingWorkoutBuilderPage } from '../pages/onboarding/onboarding-workout-builder/onboarding-workout-builder.page';
import { OnboardingModule } from '../pages/onboarding/onboarding.module';
import { PrintWorkoutPage } from '../pages/print-workout/print-workout.page';
import { AuthGuardService } from './auth-guard.service';
import { BillingGuardService } from './billing-guard.service';
import { formGuard } from './form-guard.service';
import { LoginGuardService } from './login-guard.service';

const routes: Routes = [
  {
    path: 'login',
    loadChildren: () => import('../pages/login/login.module').then(m => m.LoginModule),
    canActivate: [LoginGuardService],
    data: {
      hideSidebar: true
    },
  },
  {
    path: 'privacy-policy',
    loadChildren: () => import('../pages/privacy-policy/privacy-policy.module').then(m => m.PrivacyPolicyModule),
    data: {
      hideSidebar: true
    }
  },
  {
    path: 'terms-and-conditions',
    loadChildren: () => import('../pages/terms-and-conditions/terms-and-conditions.module').then(m => m.TermsAndConditionsModule),
    data: {
      hideSidebar: true
    }
  },
  {
    path: 'onboarding/workout-builder',
    component: OnboardingWorkoutBuilderPage,
    data: {
      hideSidebar: true
    }
  },
  {
    path: 'print/workout',
    component: PrintWorkoutPage,
    data: {
      hideSidebar: true
    }
  },
  {
    path: 'onboarding',
    component: OnboardingStartPage,
    canActivate: [LoginGuardService],
    data: {
      hideSidebar: true
    }
  },
  {
    path: 'billing',
    loadChildren: () => import('../pages/billing/billing.module').then(m => m.BillingModule),
    data: {
      hideSidebar: true
    }
  },
  {
    path: 'employee/invite/:inviteId',
    loadChildren: () => import('../pages/employee/employee-invite/employee-invite.module').then(m => m.EmployeeInvitePageModule),
    canActivate: [LoginGuardService],
    data: {
      hideSidebar: true
    }
  },
  {
    path: 'customer/invite/:licenseCode',
    loadChildren: () => import('../pages/customer/customer-invite/customer-invite.module').then(m => m.CustomerInvitePageModule),
    canActivate: [LoginGuardService],
    data: {
      hideSidebar: true
    }
  },
  {
    path: '',
    canActivate: [AuthGuardService, BillingGuardService],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'workouts'
      },
      {
        path: 'workouts',
        loadChildren: () => import('../pages/workout/workout.module').then(m => m.WorkoutModule)
      },
      {
        path: 'employees',
        loadChildren: () => import('../pages/employee/employee.module').then(m => m.EmployeeModule)
      },
      {
        path: 'exercises',
        loadChildren: () => import('../pages/exercise/exercise.module').then(m => m.ExerciseModule)
      },
      {
        path: 'assessments',
        canActivate: [formGuard],
        loadChildren: () => import('../pages/forms/forms.module').then(m => m.FormsModule)
      },
      {
        path: 'customers',
        loadChildren: () => import('../pages/customer/customer.module').then(m => m.CustomereModule)
      },
      {
        path: 'groups',
        loadChildren: () => import('../pages/group/group.module').then(m => m.GroupModule)
      },
      {
        path: 'home-screen-settings',
        loadChildren: () => import('../pages/home-screen-settings/home-screen-settings.module').then(m => m.HomeScreenSettingsPageModule)
      },
      {
        path: 'chat',
        loadChildren: () => import('../pages/chat/chat.module').then(m => m.ChatModule)
      },
      {
        path: 'calendar',
        loadChildren: () => import('../pages/calendar/calendar.module').then(m => m.CalendarModule)
      },
      {
        path: 'organization',
        loadChildren: () => import('../pages/organization/organization.module').then(m => m.OrganizationModule)
      },
      {
        path: 'onboarding/success',
        component: OnboardingStatusPage,
      },
      {
        path: 'notifications',
        loadChildren: () => import('../pages/notifications/notifications.module').then(m => m.NotificationsModule)
      },
      {
        path: 'training-session',
        loadChildren: () => import('../pages/training-session/training-session.module').then(m => m.TrainingSessionModule)
      }
    ]
  }
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
    provideAuth(() => getAuth()),
    OnboardingModule,
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
